import { get } from '@/services/http'
import { wp } from '@/lib/api'
import type { Frontpage } from '@/models/frontpage'

/**
 * Frontpage is fetched directly from the API without language handling or mapping.
 * Endpoint: /api/wp/v2/frontpage
 */
export type FrontpageData = Frontpage

export const FrontpageService = {
  async get(): Promise<FrontpageData> {
    const req = get<FrontpageData>(
      'frontpage',
      {},
      {
        client: wp,
        dedupe: true,
        retry: { retries: 2 },
      },
    )

    return await req.promise
  },
}
